/* TIRE OX — Set-of-4 pricing widget for tire product pages.
 * Adds 1 / 2 / 4 quantity buttons with live set-total math and a
 * "price per tire" callout next to Add to Cart. Tire products only
 * (detected by product type "Tires" or a tire-size pattern in the title).
 *
 * Install: Assets > tireox-set-pricing.js, then in theme.liquid above </body>:
 *   <script src="{{ 'tireox-set-pricing.js' | asset_url }}" defer></script>
 * Off-switch: remove that line.
 */
(function () {
  'use strict';

  // ---- Config ----------------------------------------------------------
  var DEFAULT_QTY = 4;        // preset quantity on page load (set to 1 to disable)
  var RUST = '#C25A2B';
  var RUST_DARK = '#A8481F';
  var CHARCOAL = '#23271F';
  var CREAM = '#F4EFE3';

  function isTireProduct() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.product && /tire/i.test(meta.product.type || '')) return true;
    } catch (e) {}
    var h1 = document.querySelector('h1');
    return !!(h1 && /\d{3}\/\d{2}R\d{2}/i.test(h1.textContent));
  }

  function getUnitPriceCents() {
    try {
      var p = window.ShopifyAnalytics.meta.product.variants[0].price;
      if (p > 0) return p;
    } catch (e) {}
    // Fallback: parse first $xx.xx near the product title
    var el = document.querySelector('main [class*="price"], main .price');
    if (el) {
      var m = el.textContent.match(/\$\s?(\d+(?:\.\d{2})?)/);
      if (m) return Math.round(parseFloat(m[1]) * 100);
    }
    return 0;
  }

  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function findForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="quantity"]')) return forms[i];
    }
    return forms[0] || null;
  }

  function build() {
    if (document.getElementById('ox-set-pricing')) return; // idempotent
    if (!isTireProduct()) return;

    var form = findForm();
    if (!form) return;
    var qtyInput = form.querySelector('[name="quantity"]') ||
                   document.querySelector('[name="quantity"]');
    var addBtn = form.querySelector('button[type="submit"], [name="add"]');
    if (!qtyInput || !addBtn) return;

    var unit = getUnitPriceCents();
    if (!unit) return;

    var wrap = document.createElement('div');
    wrap.id = 'ox-set-pricing';
    wrap.style.cssText = 'margin:14px 0 16px;font-family:inherit;';

    wrap.innerHTML =
      '<div style="font-size:13px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:' + CHARCOAL + ';margin-bottom:8px;">' +
        money(unit) + ' per tire — how many do you need?' +
      '</div>' +
      '<div id="ox-qty-btns" style="display:flex;gap:8px;flex-wrap:wrap;"></div>' +
      '<div id="ox-set-total" style="margin-top:10px;font-size:16px;font-weight:700;color:' + CHARCOAL + ';"></div>' +
      '<div style="margin-top:4px;font-size:13px;color:#5a5e54;">Free shipping + $100 roadside assistance included. Most drivers replace all 4 for even wear and handling.</div>';

    var btnRow = wrap.querySelector('#ox-qty-btns');
    var totalEl = wrap.querySelector('#ox-set-total');

    var options = [
      { q: 1, label: '1 tire' },
      { q: 2, label: '2 tires' },
      { q: 4, label: '4 — full set ★' }
    ];

    function setQty(q) {
      qtyInput.value = q;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    }

    function render() {
      var current = parseInt(qtyInput.value, 10) || 1;
      Array.prototype.forEach.call(btnRow.children, function (b) {
        var active = parseInt(b.dataset.q, 10) === current;
        b.style.background = active ? RUST : '#fff';
        b.style.color = active ? CREAM : CHARCOAL;
        b.style.borderColor = active ? RUST_DARK : '#c9c5b8';
      });
      totalEl.textContent = 'Total: ' + money(unit * current) +
        (current > 1 ? ' for ' + current + ' tires' : '');
    }

    options.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.q = o.q;
      b.textContent = o.label;
      b.style.cssText =
        'padding:10px 18px;border:2px solid #c9c5b8;border-radius:8px;background:#fff;color:' +
        CHARCOAL + ';font-size:15px;font-weight:600;cursor:pointer;transition:all .15s;';
      b.addEventListener('click', function () { setQty(o.q); });
      btnRow.appendChild(b);
    });

    qtyInput.addEventListener('change', render);
    qtyInput.addEventListener('input', render);

    // Insert above the Add to cart button block
    var anchor = addBtn.closest('div') || addBtn;
    anchor.parentNode.insertBefore(wrap, anchor);

    if (DEFAULT_QTY > 1) setQty(DEFAULT_QTY); else render();
  }

  function init() {
    build();
    // Theme sections can re-render; rebuild if our widget gets removed.
    var mo = new MutationObserver(function () {
      if (!document.getElementById('ox-set-pricing')) build();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();